import { ClientServiceMapper } from '../../../models/Client/ClientServiceMapper.js';
import { Client } from '../../../models/Client/Client.js';

class Clients {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  get() {
    return this.apiClient.get('v1/clients').then(response => Client.createFromResponse(response.data));
  }
  update(client) {
    return this.apiClient.put(`v1/clients`, client.getUpdatePayload()).then(response => {
      return {
        identifier: response.data.identifier,
        companyName: response.data.company_name
      };
    });
  }
  updateLanguage(language) {
    return this.apiClient.put('v1/clients/language', {
      language
    }).then(response => response.data);
  }
  getAvailableServices(clientId) {
    return this.apiClient.get(`v1/clients/${clientId}/services/available`).then(response => response.data.services.map(service => ClientServiceMapper.createModelFromResponse(service)));
  }
}

export { Clients };
//# sourceMappingURL=Clients.js.map
